import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

const EmptyStateContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(6),
  textAlign: 'center',
  minHeight: '400px',
}));

const IllustrationContainer = styled(Box)(({ theme }) => ({
  width: '200px',
  height: '200px',
  marginBottom: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& img': {
    maxWidth: '100%',
    maxHeight: '100%',
  },
}));

interface EmptyStateProps {
  title: string;
  description: string;
  illustration?: string;
}

export function EmptyState({ title, description, illustration }: EmptyStateProps): JSX.Element {
  return (
    <EmptyStateContainer>
      <Stack spacing={3} alignItems="center">
        {illustration && (
          <IllustrationContainer>
            <img src={illustration} alt={title} />
          </IllustrationContainer>
        )}
        <Typography variant="h5" component="h2" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary" maxWidth="600px">
          {description}
        </Typography>
      </Stack>
    </EmptyStateContainer>
  );
}
